<div class="cluster-map-marker-wrapper">
    <div class='price-cluster-wrapper'>
        <div class='price-cluster-counter'>{{summary().nrItems || 0 }}</div>
        <div class='price-cluster-price-range'>
            <div class="value">{{getMillionPrice(summary().minValue)}}</div>
            <div class="nav-push-right"></div>
            <div class="value">{{getMillionPrice(summary().maxValue)}} </div>
            <div class="unit">mill</div>
        </div>
    </div>
</div>